export const validateURLParameters = (params, navigate) => {
  // Pris validation
  if (params.has("pristyp")) {
    const timeValue = params.get("pristyp");
    const validTimeOptions = ["timvis", "dagsvis", "månadsvis", "per arbetsplats"];

    // Handle both single and multiple values
    if (timeValue.includes(",")) {
      // Multiple values case
      const timeValues = timeValue.split(",");
      const allValuesValid = timeValues.every((value) => validTimeOptions.includes(decodeURIComponent(value.trim())));

      if (!allValuesValid) {
        console.log("Invalid parameter in URL (multiple values):", timeValue);
        navigate("/404", { state: { from404ForInvalidParam: true } });
        return false;
      }
    } else {
      // Single value case
      if (!validTimeOptions.includes(decodeURIComponent(timeValue))) {
        console.log("Invalid parameter in URL (single value):", timeValue);
        navigate("/404", { state: { from404ForInvalidParam: true } });
        return false;
      }
    }
  }

  // Moms validation
  if (params.has("moms")) {
    const momsValue = params.get("moms");

    if (momsValue !== "true" && momsValue !== "false") {
      console.log("Invalid parameter in URL:", momsValue);
      // Redirect to 404 page if the parameter is invalid and set 404 state to true
      navigate("/404", { state: { from404ForInvalidParam: true } });
      return false;
    }
  }

  return true;
};
